export var getSearchParamPageNumber = function (fallbackValue) {
    if (fallbackValue === void 0) { fallbackValue = 1; }
    var size = new URLSearchParams(window.location.search).get("pageNumber");
    if (!size)
        return fallbackValue;
    return parseInt(size);
};
